var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowPage)?_c('global-layout',[_c('page-header',{attrs:{"breadcrumb":_vm.breadcrumb}}),_c('transition',{attrs:{"name":"page-toggle"}},[_c('router-view')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }